import { jsx as _jsx } from "react/jsx-runtime";
import { BellOutlined, DeleteOutlined, EditOutlined, NotificationOutlined, StopOutlined } from "@ant-design/icons";
import { ETemplateMetaDataVersionUpdateState } from "@devowl-wp/api-real-cookie-banner";
function getTemplateMetaDataVersionUpdateStateColor(status) {
    switch(status){
        case ETemplateMetaDataVersionUpdateState.Initial:
            return "blue";
        case ETemplateMetaDataVersionUpdateState.Update:
            return "orange";
        case ETemplateMetaDataVersionUpdateState.Notify:
            return "green";
        case ETemplateMetaDataVersionUpdateState.Removed:
            return "red";
        case ETemplateMetaDataVersionUpdateState.NeverReleased:
            return "magenta";
        default:
            return "grey";
    }
}
function getTemplateMetaDataVersionUpdateStateIcon(status) {
    switch(status){
        case ETemplateMetaDataVersionUpdateState.Initial:
            return /*#__PURE__*/ _jsx(BellOutlined, {});
        case ETemplateMetaDataVersionUpdateState.Update:
            return /*#__PURE__*/ _jsx(EditOutlined, {});
        case ETemplateMetaDataVersionUpdateState.Notify:
            return /*#__PURE__*/ _jsx(NotificationOutlined, {});
        case ETemplateMetaDataVersionUpdateState.Removed:
            return /*#__PURE__*/ _jsx(DeleteOutlined, {});
        case ETemplateMetaDataVersionUpdateState.NeverReleased:
            return /*#__PURE__*/ _jsx(StopOutlined, {});
        default:
            return undefined;
    }
}
function getTranslationTemplateMetaDataVersionUpdateState(status, t) {
    switch(status){
        case ETemplateMetaDataVersionUpdateState.Initial:
            return t("Initial");
        case ETemplateMetaDataVersionUpdateState.Update:
            return t("Update");
        case ETemplateMetaDataVersionUpdateState.Notify:
            return t("Notify");
        case ETemplateMetaDataVersionUpdateState.Removed:
            return t("Removed");
        case ETemplateMetaDataVersionUpdateState.NeverReleased:
            return t("Never");
        default:
            return t("Translation status not found: {{status}}", {
                status
            });
    }
}
function getTooltipTemplateMetaDataVersionUpdateState(status, t) {
    switch(status){
        case ETemplateMetaDataVersionUpdateState.Initial:
            return t("Initial release");
        case ETemplateMetaDataVersionUpdateState.Update:
            return t("Changes without notification");
        case ETemplateMetaDataVersionUpdateState.Notify:
            return t("Changes with notification");
        case ETemplateMetaDataVersionUpdateState.Removed:
            return t("Removed on release");
        case ETemplateMetaDataVersionUpdateState.NeverReleased:
            return t("Deleted before released");
        default:
            return t("Tooltip not found: {{status}}", {
                status
            });
    }
}
function calculateTemplateMetaDataVersionUpdateStateForTemplate(current, prevTemplates) {
    if (current && prevTemplates) {
        const prev = prevTemplates?.find((prev)=>prev.identifier === current.identifier);
        const status = getTemplateMetaDataVersionUpdateState(prev, current);
        current.releaseStatus = status;
    }
}
function getTemplateMetaDataVersionUpdateState(prev, current) {
    const shouldNotify = prev === undefined || prev.version !== current.version;
    const isInitialRelease = prev === undefined;
    const { isDeleted } = current;
    if (isDeleted) {
        if (isDeleted && isInitialRelease) {
            return ETemplateMetaDataVersionUpdateState.NeverReleased;
        } else {
            return ETemplateMetaDataVersionUpdateState.Removed;
        }
    } else if (isInitialRelease) {
        return ETemplateMetaDataVersionUpdateState.Initial;
    } else if (shouldNotify) {
        return ETemplateMetaDataVersionUpdateState.Notify;
    } else {
        return ETemplateMetaDataVersionUpdateState.Update;
    }
}
export { calculateTemplateMetaDataVersionUpdateStateForTemplate, getTemplateMetaDataVersionUpdateState, getTemplateMetaDataVersionUpdateStateColor, getTemplateMetaDataVersionUpdateStateIcon, getTranslationTemplateMetaDataVersionUpdateState, getTooltipTemplateMetaDataVersionUpdateState };
